import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { AuthLayout } from "@/components/app/AuthLayout";
import { authApi, apiError } from "@/lib/api";
import { AUTH } from "@/constants/testIds";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [status, setStatus] = useState(token ? "loading" : "error");
  const [message, setMessage] = useState(token ? "" : "Brak tokenu weryfikacyjnego w adresie.");
  const ran = useRef(false);

  useEffect(() => {
    if (!token || ran.current) return;
    ran.current = true;
    authApi
      .verifyEmail(token)
      .then(() => {
        setStatus("success");
        setMessage("Adres e-mail został potwierdzony.");
      })
      .catch((err) => {
        setStatus("error");
        setMessage(apiError(err.response?.data?.detail, "Link weryfikacyjny jest nieprawidłowy lub wygasł."));
      });
  }, [token]);

  return (
    <AuthLayout
      title="Weryfikacja e-mail"
      footer={
        <Link to="/biblioteka" className="font-medium text-brand-accent hover:underline">
          Przejdź do biblioteki
        </Link>
      }
    >
      {status === "loading" && (
        <div className="flex items-center gap-3 text-brand-sec">
          <div className="h-5 w-5 animate-spin rounded-full border-2 border-brand-line border-t-brand-accent" />
          Weryfikujemy Twój adres…
        </div>
      )}
      {status === "success" && (
        <div data-testid={AUTH.success} className="rounded-field border border-brand-accent/40 bg-brand-accent/10 px-4 py-4 text-sm text-brand-text">
          {message}
        </div>
      )}
      {status === "error" && (
        <div data-testid={AUTH.error} className="rounded-field border border-red-500/40 bg-red-500/10 px-4 py-4 text-sm text-red-300">
          {message}
        </div>
      )}
    </AuthLayout>
  );
}
